"use client";

import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import { SeverityIcon } from "@timeedit/ui-components";
import { Alert } from "antd";
import { t } from "i18next";
import ButtonDefault from "@src/app/components/Button/ButtonDefault.component";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};

/**
 * @todo maybe use https://github.com/bvaughn/react-error-boundary or https://sentry.io
 */

export class ErrorBoundaryDefault extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    const { fallback } = this.props;

    if (hasError) {
      return (
        fallback ?? (
          <Alert
            type="error"
            icon={<SeverityIcon severity="error" alt="" size={24} />}
            showIcon
            message={t("translation:MESSAGE.TYPE.ERROR.UNKNOWN.TITLE")}
            description={
              <div className="sg-flex sg-flex-col sg-gap-2">
                <div>
                  {error?.message ||
                    t("translation:MESSAGE.TYPE.ERROR.UNKNOWN.DESCRIPTION")}
                </div>
                <ButtonDefault
                  onClick={() => window.location.reload()}
                  type="primary"
                >
                  {t("translation:MESSAGE.TYPE.ERROR.ACTION.RETRY.TITLE")}
                </ButtonDefault>
              </div>
            }
          />
        )
      );
    }

    return this.props.children;
  }
}
